import React, { FC, Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'next-i18next';

import Icon from 'src/common/components/IconDS22';
import styles from './PasswordVisibilityToggle.module.scss';

type PasswordVisibilityToggleProps = {
  isPasswordVisible: boolean;
  setIsPasswordVisible: Dispatch<SetStateAction<boolean>>;
};

const PasswordVisibilityToggle: FC<PasswordVisibilityToggleProps> = ({
  isPasswordVisible,
  setIsPasswordVisible,
}) => {
  const [t] = useTranslation('common');
  const handlePasswordVisibilityToggle = () => setIsPasswordVisible(!isPasswordVisible);

  return (
    <button
      className={styles.root}
      type="button"
      onClick={handlePasswordVisibilityToggle}
      aria-label={t('password-visibility-aria-label')}
    >
      <Icon id={isPasswordVisible ? 'eye' : 'eye-slash'} />
    </button>
  );
};

export default PasswordVisibilityToggle;
